/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Apr 27 2022
*  File : production.ts
*******************************************/

import { commonConfig } from "./common.js";

export const config = commonConfig;

config.host = "api.geopop.it";
config.domain = "geopop.it";
config.mainUrl = "https://www.geopop.it";
config.secure = true;
config.debug = true;
config.webPush.serviceWorkerHost = "www.geopop.it";
config.snhubConfig.domain = "geopop.it";
config.cookies.cookieDomain = ".geopop.it";

config.snhubConfig.secure = true;
config.snhubConfig.host = "api.geopop.it";
config.snhubConfig.enabled = true;


config.ga4.cookieDomain = ".geopop.it";
config.assetsDistro = "https://d18u0p9ui3w1qy.cloudfront.net";
config.loginManager.excludeFromCta = {
    fb: true
}

config.membership = {
    enable: true,
    debugMode: false,
    giftSupport: true,
    idtoken_name: "pr_idtok",
    landingUrl: "https://www.geopop.it/missione-cultura",
    cardSupport: true,
    anonBuySupport: true
}

config.loginManager.actual_providers.email.enabled = true;
config.loginManager.actual_providers.email.codeLoginAllowed = true;